import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { firstError } from 'common/validation';
import { getStep } from 'common/selectors';
import * as steps from 'common/steps';
import { getErrors, getFields } from 'common/stepReducerUtil';
import { getLanguages } from 'dissertation-info/dissertationInfoReducer';
import Autocomplete from 'general-components/Autocomplete';
import styles from './DissertationInfoLanguageAutocomplete.css';
import {
  FIELD_BLURRED,
  LANGUAGE_CHANGED,
} from 'dissertation-info/dissertationInfoActions';

const mapLanguages = R.memoize(
  R.reduce((acc, next) => R.assoc(next.code, next.name, acc), {}),
);

const DissertationInfoLanguageAutocomplete = ({
  errors,
  language,
  onBlur,
  onLanguageChanged,
}) => (
  <Autocomplete
    className={styles.language}
    label="Primary language"
    multiple={false}
    source={mapLanguages(getLanguages())}
    showSuggestionsWhenValueIsSet={true}
    direction="down"
    suggestionMatch="anywhere"
    value={language}
    onChange={onLanguageChanged}
    error={firstError(errors, 'language.code')}
    onBlur={() => onBlur('language.code', language)}
  />
);

const mapState = state =>
  R.pipe(
    getStep(steps.DISSERTATION_INFO),
    R.applySpec({
      errors: getErrors,
      language: R.pipe(getFields, R.path(['language', 'code'])),
    }),
  );

const mapDispatch = dispatch => ({
  onBlur: (field, value) => dispatch({ type: FIELD_BLURRED, field, value }),
  onLanguageChanged: (code, event) =>
    dispatch({ type: LANGUAGE_CHANGED, code }),
});

export default connect(mapState, mapDispatch)(
  DissertationInfoLanguageAutocomplete,
);



// WEBPACK FOOTER //
// ./src/dissertation-info/components/DissertationInfoLanguageAutocomplete.js